export function ensureHttpsUrl(url: string): string {
  if (!url || url.trim() === '') {
    return url;
  }

  const trimmedUrl = url.trim();

  if (trimmedUrl.startsWith('https://')) {
    return trimmedUrl;
  }

  if (trimmedUrl.startsWith('http://')) {
    return trimmedUrl.replace(/^http:\/\//, 'https://');
  }

  return `https://${trimmedUrl}`;
}

function asMetadataRecord(value: unknown): Record<string, unknown> | undefined {
  return typeof value === 'object' && value !== null
    ? (value as Record<string, unknown>)
    : undefined;
}

export function getMetadataSolanaDappStore<T>(
  metadata: unknown,
): T | undefined {
  const record = asMetadataRecord(metadata);
  const extensions = asMetadataRecord(record?.extensions);
  return asMetadataRecord(extensions?.solana_dapp_store) as T | undefined;
}

export function getTokenReleaseSolanaDappStore<T>(
  tokenJson: unknown,
): T | undefined {
  const tokenData = asMetadataRecord(asMetadataRecord(tokenJson)?.data);
  const nftRelease = asMetadataRecord(tokenData?.nft_release);
  return getMetadataSolanaDappStore<T>(nftRelease);
}

function truncateForValidation(str: string, maxLength: number): string {
  return str.substring(0, maxLength - 1);
}

export function ensureIconInMediaArray<T extends { purpose: string }>(
  mediaArray: T[],
  iconUri?: string,
): void {
  const hasIcon = mediaArray.some((media) => media.purpose === 'icon');
  if (!hasIcon) {
    throw new Error(
      iconUri
        ? `NFT media array is missing required icon metadata for ${iconUri}`
        : 'NFT media array is missing a required icon asset.',
    );
  }
}

export function createReleaseDetails(releaseData: {
  licenseUrl: string;
  privacyPolicyUrl: string;
  shortDescription: string;
  longDescription: string;
  whatsNew: string;
  localizedName: string;
}): {
  updated_on: string;
  license_url: string;
  copyright_url: string;
  privacy_policy_url: string;
  localized_resources: {
    short_description: string;
    long_description: string;
    new_in_version: string;
    name: string;
  };
} {
  return {
    updated_on: new Date().toISOString(),
    license_url: ensureHttpsUrl(releaseData.licenseUrl),
    copyright_url: '',
    privacy_policy_url: ensureHttpsUrl(releaseData.privacyPolicyUrl),
    localized_resources: {
      short_description: '5',
      long_description: '1',
      new_in_version: '2',
      name: '4',
    },
  };
}

export function createI18nTranslations(
  locale: string,
  translations: {
    name: string;
    shortDescription: string;
    longDescription: string;
    newInVersion: string;
  },
): Record<string, Record<string, string>> {
  return {
    [locale]: {
      '1': translations.longDescription,
      '2': translations.newInVersion,
      '4': translations.name,
      '5': truncateForValidation(translations.shortDescription, 50),
    },
  };
}

export function extractFilename(uri: string, maxLength = 20): string {
  if (!uri) return 'No filename';

  const filename = uri.split('/').pop();
  if (filename) return filename;

  return uri.substring(uri.length - maxLength);
}
